module.exports = __webpack_public_path__ + "static/media/carriedSprayer.243bd7c4.png";